/* eslint-disable sort-keys */
/* eslint-disable max-len */
export const styledSwitch = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.2rem',
    marginBottom: '1rem',
    variants: {disabled: {true: {opacity: 0.5}}},
}

export const styledHorizontal = {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: '0.8rem',
    marginTop: '0.6rem',
}

export const styledDescription = {
    color: '$checkboxDescription',
    cursor: 'pointer',
    fontWeight: 'normal',
}

export const styledInput = {
    '& + svg': {color: '$switchIcon'},
    '&::before': {
        backgroundColor: '$switchThumbBackground',
        borderColor: '$switchThumbBorder',
        borderRadius: '$switchThumb',
        borderStyle: '$switchThumb',
        borderWidth: '$switchThumb',
        boxSizing: 'border-box',
        content: '',
        height: '18px',
        left: '2px',
        position: 'absolute',
        top: '2px',
        transition: 'all 0.3s',
        width: '18px',
        zIndex: 1,
    },
    '&:checked': {
        '& + svg': {color: '$switchIconChecked'},
        '&::before': {
            backgroundColor: '$switchThumbBackgroundChecked',
            left: 'unset',
            transform: 'translateX(23px)',
        },
        'backgroundColor': '$switchBackgroundChecked',
        'borderColor': '$switchBorderChecked',
    },
    '&:disabled': {
        '& + svg': {color: '$switchIconDisabled'},
        '&::before': {
            backgroundColor: '$switchThumbBackgroundDisabled',
            borderColor: '$switchThumbBorderDisabled',
        },
        '&:checked': {
            '+ svg': {color: '$switchIconCheckedDisabled'},
            '&::before': {
                backgroundColor: '$switchThumbBackgroundCheckedDisabled',
                borderColor: '$switchThumbBorderCheckedDisabled',
            },
            'backgroundColor': '$switchBackgroundCheckedDisabled',
            'borderColor': '$switchBorderCheckedDisabled',
        },
        'backgroundColor': '$switchBackgroundDisabled',
        'borderColor': '$switchBorderDisabled',
    },
    '&:focus-visible:not(:disabled)': {
        '& + svg': {color: '$switchIconFocus'},
        '&::before': {
            backgroundColor: '$switchThumbBackgroundFocus',
            borderColor: '$switchThumbBorderFocus',
        },
        '&:checked': {
            '& + svg': {color: '$switchIconCheckedFocus'},
            '&::before': {
                backgroundColor: '$switchThumbBackgroundCheckedFocus',
                borderColor: '$switchThumbBorderCheckedFocus',
            },
            'backgroundColor': '$switchBackgroundCheckedFocus',
            'borderColor': '$switchBorderCheckedFocus',
        },
        'backgroundColor': '$switchBackgroundFocus',
        'borderColor': '$switchBorderFocus',
        'outlineColor': '$switchOutlineFocus',
        'outlineStyle': 'solid',
        'outlineWidth': '2px',
    },
    '&:hover:not(:disabled)': {
        '& + svg': {color: '$switchIconHover'},
        '&::before': {
            backgroundColor: '$switchThumbBackgroundHover',
            borderColor: '$switchThumbBorderHover',
        },
        '&:checked': {
            '& + svg': {color: '$switchIconCheckedHover'},
            '&::before': {
                backgroundColor: '$switchThumbBackgroundCheckedHover',
                borderColor: '$switchThumbBorderCheckedHover',
            },
            'backgroundColor': '$switchBackgroundCheckedHover',
            'borderColor': '$switchBorderCheckedHover',
        },
        'backgroundColor': '$switchBackgroundHover',
        'borderColor': '$switchBorderHover',
    },
    'appearance': 'none',
    'backgroundColor': '$switchBackground',
    'borderColor': '$switchBorder',
    'borderRadius': '$switch',
    'borderStyle': '$switch',
    'borderWidth': '$switch',
    'flex': 'none',
    'height': '24px',
    'margin': 0,
    'position': 'relative',
    'transition': 'background-color 0.3s, border-color 0.3s',
    'userSelect': 'none',
    'width': '45px',
}

export const styledSwitchInnerWrapper = {
    position: 'relative',
    svg: {
        position: 'absolute',
        top: 'calc(50% - 2px)',
        right: '5px',
        transform: 'translate(0, -50%)',
        width: '16px',
        height: '16px',
        pointerEvents: 'none',
    },
    variants: {
        isOn: {
            true: {
                svg: {
                    left: '5px',
                    right: 'initial',
                },
            },
        },
    },
}
